export default __webpack_public_path__ + "static/media/workouttimes_4@2x.5695aa3e.jpg";